import { filter, flow, map } from 'lodash/fp';
import React from 'react';

export default (settings, guest) =>
  flow(
    filter(
      each => settings[`createVisitIdent${each}`] && guest[`ident${each}`]
    ),
    map(value => (
      <span key={`createVisitIdent-${value}-label`}>
        {settings[`createVisitIdent${value}Label`]}
        <br />
      </span>
    ))
  )(['1', '2', '3']);
